import React from 'react';
import { OfferRequisitionFeed } from '../../../../../entities/ApplicationFeed';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { AlertObject } from '../../../../../components/Alert';
import { GenericEntry } from '../..';
import { getNounWithPossessiveCase } from '../../../../../utils/grammar';
import { ViewRequisitionButton } from '../ViewRequisitionButton';

interface PropTypes {
  application: Application;
  currentUser: User;
  isLastItemInPage: boolean;
  entry: OfferRequisitionFeed;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function OfferRequisitionUpdated(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-file-medical'
      iconClassName='bg-blue-gray-light'
      title={
        <span>
          <strong>{props.entry.authorName}</strong> updated{' '}
          <strong>
            {getNounWithPossessiveCase(props.application.candidate.name)}
          </strong>{' '}
          offer requisition.
        </span>
      }
      date={props.entry.createdAt}
      {...props}
    >
      <ViewRequisitionButton entry={props.entry} />
    </GenericEntry>
  );
}
